import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';

import { ReplaySubject, BehaviorSubject, catchError, Observable } from 'rxjs';

import { MessageService } from 'src/app/core/services/message.service';
import { PageDonnee } from 'src/app/shared/interfaces/page-donnee';

@Injectable({
  providedIn: 'root'
})
export class TarifConfigurationService {

  constructor(
    private messageService: MessageService
    ,private http: HttpClient
    ) { }

   private donneesSubject = new BehaviorSubject<any[]>([]);
   public donnees$ = this.donneesSubject.asObservable();

   private chargementSubject = new BehaviorSubject<boolean>(false);
   public chargement$ = this.chargementSubject.asObservable();

   private indexPageSubject = new ReplaySubject<number>(0);
   public indexPage$ = this.indexPageSubject.asObservable();

   private taillePageSubject = new ReplaySubject<number>(10);
   public taillePage$ = this.taillePageSubject.asObservable();

   private totalElementsDonneesSubject = new BehaviorSubject<number>(0);
   public totalElementsDonnees$ = this.totalElementsDonneesSubject.asObservable();

  obtenirTarifConfiguration(): Observable<any> {
    const url = `${environment.apiurl}` + 'tarif-configuration/active';
    return this.http.get<any>(url).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

  obtenirListeTarifConfiguration(page:number, taille:number) {
    const url = `${environment.apiurl}tarif-configuration/actives`;
    this.http.get<any[]>(url).subscribe(donnees => {
      const list = Array.isArray(donnees) ? donnees : [];
      this.donneesSubject.next(list);
      this.chargementSubject.next(false);
      this.indexPageSubject.next(0);
      this.totalElementsDonneesSubject.next(list.length);
    });
  }

  enregistrerTarifConfiguration(formulaireTarifConfiguration: any, creerTarif: boolean): Observable<any> {
    if(creerTarif) {
      const url = `${environment.apiurl}` + 'tarif-configuration';
      const { id, ...body } = formulaireTarifConfiguration;
      return this.http.post<any>(url, body).pipe(
        catchError(this.messageService.gererErreur)
      );
    } else {
      const url = `${environment.apiurl}` + 'tarif-configuration/' + formulaireTarifConfiguration.id;
      //const { id, ...donneesTarif } = formulaireTarifConfiguration;
      //return this.http.put<any>(url, donneesTarif).pipe(
      return this.http.put<any>(url, formulaireTarifConfiguration).pipe(
        catchError(this.messageService.gererErreur)
      );
    }
  }

  supprimerTarifConfiguration(id: number): Observable<any> {
    const url = `${environment.apiurl}tarif-configuration/${id}`;
    return this.http.delete<any>(url).pipe(
      catchError(this.messageService.gererErreur)
    );
  }

}
